import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionsComponent from '../../components/tools/ActionsComponent/ActionsComponent';
import { selectOrder, setSelectedTask } from '../../actions/tools/OrdersSearchActions';
import { setShowTools } from '../../actions/index';
import { extractSelectedTicketFromState, getSimplrAccountIdOfSelectedTicket } from '../../extractFromState';
import * as toolSelectors from '../../selectors/tools';
import { selectSubscription, selectSubscriptionTask } from 'actions/tools/CommonSubscriptionActions';

function mapStateToProps(state) {
  const ticket = extractSelectedTicketFromState(state);

  return {
    ordersSearch: toolSelectors.getOrdersSearchProperties(state),
    selectedSubscription: toolSelectors.getSelectedSubscription(state),
    searchType: toolSelectors.selectToolGeneralSearchType(state),
    orderingSystem: toolSelectors.getOrderingSystem(state),
    selectedOrder: toolSelectors.getSelectedOrder(state),
    simplrAccountPtrId: getSimplrAccountIdOfSelectedTicket(state),
    subscriptionSelectedTask: toolSelectors.selectSubscriptionSelectedTask(state),
    subscriptionSystem: toolSelectors.selectSubscriptionSystem(state),
    general: (state.ui && state.ui.tools && state.ui.tools.general) || {},
    platformTicketId: ticket && ticket.platformTicketId,
    toolsLoading: toolSelectors.getToolsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSelectedTask,
      selectOrder,
      setShowTools,
      selectSubscription,
      selectSubscriptionTask,
    },
    dispatch
  );

const ActionsContainer = connect(mapStateToProps, mapDispatchToProps)(ActionsComponent);

export default ActionsContainer;
